<template>
  <div class="home">
    <Lang/>
    <div class="home-logo">
      <div class="home-logo-img">
          <!-- <van-image src="/logo?t=123"/> -->
          <van-image :src="require('../asset/logo.png')"></van-image>
      </div>

      <div>{{$t("message.logo")}}</div>
    </div>

    <van-grid
            clickable
            :column-num="2"
            :gutter="10">
<!--      <van-grid-item icon="user-circle-o" :text="$t('message.menu.user')" to="/user" />-->
      <van-grid-item icon="after-sale" :text="$t('message.menu.stock')" to="/stock" />
      <van-grid-item icon="bill-o" :text="$t('message.menu.mine')" to="/mine" />
      <!-- <van-grid-item icon="bag-o" :text="$t('message.menu.stocked')" to="/stocked" /> -->
      <van-grid-item icon="cash-on-deliver" :text="$t('message.menu.yearStock')" to="/yearStock" />
      <van-grid-item icon="balance-pay" :text="$t('message.menu.myStock')" to="/myStock" />
      <van-grid-item icon="tv-o" :text="$t('message.menu.ipadStock')" to="/ipadStock" />
      <van-grid-item icon="tv-o" :text="$t('message.menu.myIpadStock')" to="/myIpadStock" />
<!--      <van-grid-item icon="orders-o" :text="$t('message.menu.req')" to="/req" />-->
<!--      <van-grid-item icon="logistics" :text="$t('message.menu.out')" to="/held?type=out" />-->
<!--      <van-grid-item icon="bag-o" :text="$t('message.menu.take')" to="/held?type=take" />-->
<!--      <van-grid-item icon="share" :text="$t('message.menu.hand')" to="/held?type=hand" />-->
<!--      <van-grid-item icon="bill-o" text="资产申请" to="/user" />-->
<!--      <van-grid-item icon="certificate" :text="$t('message.menu.held')" to="/service" />-->
    </van-grid>
  </div>
</template>

<script>

import Lang from "@/components/language";
import {
  Image,
  Grid,
  GridItem
} from 'vant';

export default {
  components: {
    Lang,
    [Image.name]: Image,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem
  },
  data () {
    return {
    }
  },
};
</script>

<style lang="less">

.home {
  padding: 80px 15px 50px;

  .van-grid-item__content {
    border-radius: 10px;
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
    color: #07c160;
  }

  &-logo {
    text-align: center;
    font-size: 20px;
    line-height: 20px;
    color: #00bebe;
    margin-bottom: 60px;

    &-img {
        width: 50%;
        margin:0 auto 15px;
    }
  }

  &-title {
    font-size: 24px;

  }

  &-subtitle {
    font-size: x-small;
  }

}
</style>
